import React from 'react';
import {
  Box,
  Container,
  Typography,
  CircularProgress,
  Paper,
  Stack
} from '@mui/material';
import { Storage, Refresh } from '@mui/icons-material';

export default function DatabaseRestartingPage({isCaseDatabase = false}) {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5'
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={3}
          sx={{
            padding: 4,
            textAlign: 'center',
            borderRadius: 2
          }}
        >
          <Stack spacing={3} alignItems="center">
            <Box
              sx={{
                position: 'relative',
                display: 'inline-flex',
                marginBottom: 2
              }}
            >
              <Storage
                sx={{
                  fontSize: 80,
                  color: 'primary.main',
                  opacity: 0.3
                }}
              />
              <CircularProgress
                size={100}
                thickness={2}
                sx={{
                  position: 'absolute',
                  top: -10,
                  left: -10,
                  color: 'primary.main'
                }}
              />
              <Refresh
                sx={{
                  fontSize: 32,
                  color: 'primary.main',
                  position: 'absolute',
                  bottom: 8,
                  right: 8,
                  animation: 'spin 2s linear infinite',
                  '@keyframes spin': {
                    '0%': {
                      transform: 'rotate(0deg)'
                    },
                    '100%': {
                      transform: 'rotate(360deg)'
                    }
                  }
                }}
              />
            </Box>

            <Typography
              variant="h4"
              component="h1"
              sx={{
                fontWeight: 600,
                color: 'text.primary'
              }}
            >
                {isCaseDatabase ? 'Case Database is Restarting' : 'Livisibly Database is Restarting'}
            </Typography>

            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ maxWidth: 400 }}
            >
              Our system is currently restarting the database.
            </Typography>

            <Typography
              variant="body2"
              color="text.secondary"
              sx={{
                fontStyle: 'italic',
                marginTop: 2
              }}
            >
              This process typically takes a few minutes. Your data is safe and secure.
            </Typography>

            <Typography
              variant="caption"
              color="text.disabled"
              sx={{ marginTop: 2 }}
            >
              Please do not close this window. The page will refresh automatically.
            </Typography>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
}